const tokenKey = "USER_TOKEN"


export function get(){
    return  localStorage.getItem(tokenKey) || '';
}

export function set(token){
    localStorage.setItem(tokenKey,token);
}

export function del(){
    localStorage.setItem(tokenKey,null);
}

